import {
  OPEN_WORKFLOW_CREATION_WIZARD,
  CLOSE_WORKFLOW_CREATION_WIZARD,
} from 'actions/workflowCreationWizard';

function getInitialState() {
  return {
    integrationType: undefined,
  };
}

export default function workflowCreationWizardReducer(
  state = getInitialState(),
  action,
) {
  switch (action.type) {
    case OPEN_WORKFLOW_CREATION_WIZARD: {
      return {
        integrationType: action.payload.integrationType,
      };
    }
    case CLOSE_WORKFLOW_CREATION_WIZARD: {
      return getInitialState();
    }
    default:
      return state;
  }
}
